import { LbaItemTag } from "@/components/SearchForTrainingsAndJobs/components/LbaItemTag"

export const TagOffreEmploi = () => {
  return (
    <LbaItemTag color="darkBlue" iconImageUri="/images/briefcase.svg">
      OFFRE D'EMPLOI
    </LbaItemTag>
  )
}
